import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { VoucherService } from "../api";
import { Terminal } from "@mui/icons-material";

export const actionGetListVoucherDoctor = createAsyncThunk(
  "voucher/listVoucherDoctor",
  async (_, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doGetListVoucherDoctor();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionGetDetailVoucherDoctor = createAsyncThunk(
  "voucher/detailVoucherDoctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doGetDetailVoucherDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionGetListVoucherUser = createAsyncThunk(
  "voucher/listVoucherUser",
  async () => {
    try {
      const res = await VoucherService.doGetListVoucherUser();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return message;
    }
  }
);

export const actionCreateVoucherDoctor = createAsyncThunk(
  "voucher/createVoucherDoctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doCreateVoucherDoctor(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateVoucherDoctor = createAsyncThunk(
  "voucher/updateVoucherDoctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doUpdateVoucherDoctor(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionDeleteVoucherDoctor = createAsyncThunk(
  "voucher/deleteVoucherDoctor",
  async (id, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doDeleteVoucherDoctor(id);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionBuyVoucherDoctor = createAsyncThunk(
  "voucher/buyVoucherDoctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doBuyVoucherDoctor(data);

      if (!res.data.error) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCheckQueyVoucher = createAsyncThunk(
  "voucher/check-quey-voucher",
  async (data, { rejectWithValue }) => {
    try {
      const res = await VoucherService.doCheckQueyVoucher(data);

      if (!res.data.error) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const voucherSlice = createSlice({
  name: "voucher",
  initialState: {
    listVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    detailVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    listVoucherUser: {
      loading: false,
      data: null,
      error: "",
    },
    createVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    updateVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    deleteVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    buyVoucherDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    checkQueyVoucher: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // check Quey Voucher
      .addCase(actionCheckQueyVoucher.pending, (state) => {
        state.checkQueyVoucher.loading = true;
      })
      .addCase(actionCheckQueyVoucher.fulfilled, (state, action) => {
        state.checkQueyVoucher.loading = false;
        state.checkQueyVoucher.data = action.payload;
      })
      .addCase(actionCheckQueyVoucher.rejected, (state, action) => {
        state.checkQueyVoucher.loading = false;
        state.checkQueyVoucher.data = action.payload;
        state.checkQueyVoucher.error =
          action.error.message || "Something went wrong";
      })
      // listVoucherDoctor
      .addCase(actionGetListVoucherDoctor.pending, (state) => {
        state.listVoucherDoctor.loading = true;
      })
      .addCase(actionGetListVoucherDoctor.fulfilled, (state, action) => {
        state.listVoucherDoctor.loading = false;
        state.listVoucherDoctor.data = action.payload;
      })
      .addCase(actionGetListVoucherDoctor.rejected, (state, action) => {
        state.listVoucherDoctor.loading = false;
        state.listVoucherDoctor.data = action.payload;
        state.listVoucherDoctor.error =
          action.error.message || "Something went wrong";
      })
      // detailVoucherDoctor
      .addCase(actionGetDetailVoucherDoctor.pending, (state) => {
        state.detailVoucherDoctor.loading = true;
      })
      .addCase(actionGetDetailVoucherDoctor.fulfilled, (state, action) => {
        state.detailVoucherDoctor.loading = false;
        state.detailVoucherDoctor.data = action.payload;
      })
      .addCase(actionGetDetailVoucherDoctor.rejected, (state, action) => {
        state.detailVoucherDoctor.loading = false;
        state.detailVoucherDoctor.data = action.payload;
        state.detailVoucherDoctor.error =
          action.error.message || "Something went wrong";
      })
      // listVoucherUser
      .addCase(actionGetListVoucherUser.pending, (state) => {
        state.listVoucherUser.loading = true;
      })
      .addCase(actionGetListVoucherUser.fulfilled, (state, action) => {
        state.listVoucherUser.loading = false;
        state.listVoucherUser.data = action.payload;
      })
      .addCase(actionGetListVoucherUser.rejected, (state, action) => {
        state.listVoucherUser.loading = false;
        state.listVoucherUser.data = action.payload;
        state.listVoucherUser.error =
          action.error.message || "Something went wrong";
      })
      // createVoucherDoctor
      .addCase(actionCreateVoucherDoctor.pending, (state) => {
        state.createVoucherDoctor.loading = true;
      })
      .addCase(actionCreateVoucherDoctor.fulfilled, (state, action) => {
        state.createVoucherDoctor.loading = false;
        state.createVoucherDoctor.data = action.payload;
      })
      .addCase(actionCreateVoucherDoctor.rejected, (state, action) => {
        state.createVoucherDoctor.loading = false;
        state.createVoucherDoctor.data = action.payload;
        state.createVoucherDoctor.error =
          action.error.message || "Something went wrong";
      })
      // updateVoucherDoctor
      .addCase(actionUpdateVoucherDoctor.pending, (state) => {
        state.updateVoucherDoctor.loading = true;
      })
      .addCase(actionUpdateVoucherDoctor.fulfilled, (state, action) => {
        state.updateVoucherDoctor.loading = false;
        state.updateVoucherDoctor.data = action.payload;
      })
      .addCase(actionUpdateVoucherDoctor.rejected, (state, action) => {
        state.updateVoucherDoctor.loading = false;
        state.updateVoucherDoctor.data = action.payload;
        state.updateVoucherDoctor.error =
          action.error.message || "Something went wrong";
      })
      // deleteVoucherDoctor
      .addCase(actionDeleteVoucherDoctor.pending, (state) => {
        state.deleteVoucherDoctor.loading = true;
      })
      .addCase(actionDeleteVoucherDoctor.fulfilled, (state, action) => {
        state.deleteVoucherDoctor.loading = false;
        state.deleteVoucherDoctor.data = action.payload;
      })
      .addCase(actionDeleteVoucherDoctor.rejected, (state, action) => {
        state.deleteVoucherDoctor.loading = false;
        state.deleteVoucherDoctor.data = action.payload;
        state.deleteVoucherDoctor.error =
          action.error.message || "Something went wrong";
      })
      // buyVoucherDoctor
      .addCase(actionBuyVoucherDoctor.pending, (state) => {
        state.buyVoucherDoctor.loading = true;
      })
      .addCase(actionBuyVoucherDoctor.fulfilled, (state, action) => {
        state.buyVoucherDoctor.loading = false;
        state.buyVoucherDoctor.data = action.payload;
      })
      .addCase(actionBuyVoucherDoctor.rejected, (state, action) => {
        state.buyVoucherDoctor.loading = false;
        state.buyVoucherDoctor.data = action.payload;
        state.buyVoucherDoctor.error = "";
      });
  },
});

export default voucherSlice.reducer;
export const { actions, reducer } = voucherSlice;
